import React, { useState } from 'react';
import styles from '../styles/Navbar.module.css';
import { Link } from 'react-router-dom';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen); // Toggle the state
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <nav>
      <div className={styles.navbarContainer}>
        <Link to='/' onClick={scrollToTop}>
          <img src='./split-heritage-logo.svg' alt='logo' className={styles.mobileLogo}></img>
        </Link>
        <img 
          src='./hamburger-menu.svg' 
          alt='hamburger-menu' 
          className={styles.hamburger} 
          onClick={toggleMenu} // Open/close mobile menu
        />
        <ul className={`${styles.navbarDesktop} ${isMenuOpen ? styles.showMenu : ''}`}>
          <li>
            <Link to='/ourMission' className={styles.link} onClick={scrollToTop}>Our mission</Link>
          </li>
          <li>
            <Link to='/projects' className={styles.link} onClick={scrollToTop}>Projects</Link>
          </li>
          <li>
            <Link to='/contactUs' className={styles.link} onClick={scrollToTop}>Contact us</Link>
          </li>
        </ul>
      </div>

      {/* Overlay mobile menu */}
      {isMenuOpen && (
        <div className={styles.mobileMenu}>
          <ul>
            <li>
              <Link to='/ourMission' className={styles.link} onClick={() => { toggleMenu(); scrollToTop(); }}>
                Our mission
              </Link>
            </li>
            <li>
              <Link to='/projects' className={styles.link} onClick={() => { toggleMenu(); scrollToTop(); }}>
                Projects
              </Link>
            </li>
            <li>
              <Link to='/contactUs' className={styles.link} onClick={() => { toggleMenu(); scrollToTop(); }}>
                Contact us
              </Link>
            </li>
          </ul>
        </div>
      )}
    </nav>
  );
};

export default Header;
